import { render, staticRenderFns } from "./SubTypeProps.vue?vue&type=template&id=77e87301"
import script from "./SubTypeProps.vue?vue&type=script&lang=js"
export * from "./SubTypeProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports